module.exports = __webpack_public_path__ + "static/img/cp05.2fdbf04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cp05.png
// module id = 9QdT
// module chunks = 1